import _ from 'lodash';
import { getField, updateField } from 'vuex-map-fields';
const state = {
    inventario: {
        modelorel: {
            modelo: null,
            marca: {
                name: null
            },
            lineas: {
                name: null
            },
            version: {
                name: null,
                cod_fasecolda: null,

                meta_keys: {
                    clindraje: 0
                }
            }
        },
    },
    _id: null,
    clientes: {
        nombre: null,
        apellido: null
    },
    created_at: null,
    fotos: [],
    opciones: [],
    basico: {
        origen: null,
        canal: null,
        presupuesto: 0,
        min_mostrar: 0,
        fecha_cita: null
    },
    forma_pago: {
        efectivo: null,
        efectivo_valor: 0,
        usado: null,
        credito: null,
        conseguir: null
    },
    credito_form: {
        valor_financiar: 0
    },
    vehiculo_usado: {
        estado: 'pendiente',
        vr_publicacion: 0,
        kilometraje: 0,
        marca: null,
        linea: null,
        version: null,
        modelo: null
    },
    cotizacion: {
        vr_publicacion: 0,
        vr_retoma: 0,
        vr_sugerido: 0,
        vr_minimo: 0
    }
};
const mutations = {
    updateField,
    updatePropuesta: (state, payload) => {
        state.inventario = payload.inventario;
        state._id = payload._id;
        if(payload.clientes){
            state.clientes = payload.clientes;
        }
        if(payload.inventario.fichatecnica.tipo_plan == 'gratis'){
            state.fotos = payload.inventario.fichatecnica.inspeccion_mecanica.fotos;
        }else{
            state.fotos = payload.inventario.fichatecnica.inspeccion.fotosvideo.fotos;
        }
        if(payload.usado && payload.usado.estado_principal !== 'cotizacion'){
            state.vehiculo_usado.estado = 'cotizado';
            state.vehiculo_usado.vr_publicacion = payload.usado.fichatecnica.cotizacion.vr_publicacion;
            state.vehiculo_usado.marca = payload.necesidad.vehiculo_usado.val_marca;
            state.vehiculo_usado.kilometraje = payload.necesidad.vehiculo_usado.kilometraje;
            state.vehiculo_usado.linea = payload.necesidad.vehiculo_usado.val_linea;
            state.vehiculo_usado.version = payload.necesidad.vehiculo_usado.val_modelo;
            state.vehiculo_usado.modelo = payload.necesidad.vehiculo_usado.val_version;
           
            state.cotizacion.vr_publicacion = payload.usado.fichatecnica.cotizacion.vr_publicacion;
            state.cotizacion.vr_retoma = payload.usado.fichatecnica.cotizacion.vr_retoma;
            state.cotizacion.vr_sugerido = payload.usado.fichatecnica.cotizacion.vr_sugerido;
            state.cotizacion.vr_minimo = payload.usado.fichatecnica.cotizacion.vr_minimo;
            
        }
        if(payload.opciones){
            state.opciones = payload.opciones;
        }
        state.created_at = payload.created_at;
        state.forma_pago = payload.necesidad.forma_pago;
        state.basico = payload.necesidad.basico;
        state.credito_form = payload.necesidad.credito_form;
    },
};
const getters = {
    getField,
};
export default {
    namespaced: true,
    state,
    mutations,
    getters
}
